import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

const initState = {
  passages: [],
  passageIndex: 0,
  isSummativeConclusionSolved: false,
  isClosingStdItem: false,
  strikeCount: 0,
  completedQuestions: [],
  currentQuestionIndex: -1,
  question: null,
  attempt: 0,
};

const standardItemReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_LEVEL_INDEX:
      return {
        ...state,
        strikeCount: payload.strikeCount,
      };

    case REDUX_ACTIONS.INITIALIZE_ROUND:
      return {
        ...initState,
        strikeCount: state.strikeCount,
      };

    case REDUX_ACTIONS.INITIALIZE_STANDARD_ITEM:
      return {
        ...state,
        passages: payload.passages,
        isClosingStdItem: false,
        completedQuestions: [],
      };

    case REDUX_ACTIONS.COMPLETE_QUESTION: {
      return {
        ...state,
        completedQuestions: state.completedQuestions.concat(state.currentQuestionIndex),
        isSummativeConclusionSolved: payload.isSummationFactCorrect,
      };
    }

    case REDUX_ACTIONS.OPEN_NEXT_QUESTION: {
      return {
        ...state,
        currentQuestionIndex: payload.nextIndex,
        question: payload.question,
        attempt: 0,
      };
    }

    case REDUX_ACTIONS.INCREASE_ATTEMPT: {
      const { isCorrect } = payload;

      const attempt = state.attempt + 1;
      const isFirstAttempt = attempt === 1;

      return {
        ...state,
        strikeCount: !isCorrect && isFirstAttempt ? state.strikeCount + 1 : state.strikeCount,
        attempt,
      };
    }

    case REDUX_ACTIONS.COMPLETE_STD_ITEM: {
      return {
        ...state,
        isClosingStdItem: true,
      };
    }

    case REDUX_ACTIONS.SWITCH_PASSAGE: {
      return {
        ...state,
        passageIndex: state.passages.findIndex(passage => passage.id === payload),
      };
    }

    default:
      return state;
  }
};

export default standardItemReducer;
